import { useMutation, useQueryClient } from '@tanstack/react-query'
import api from '@/lib/api'
import { useAccessToken } from '@/features/auth/state/auth'

type Params = { id_edit: string; html: string }

export function useApplyEditAgreement() {
  const queryClient = useQueryClient()
  const token = useAccessToken()
  return useMutation({
    mutationFn: async ({ id_edit, html }: Params) => {
      console.log(id_edit, html)
      const response = await api.patch(
        `agreement-edit/apply/${id_edit}`,
        { html },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      if (!response.data) throw new Error('Erro ao aplicar alteração de Minuta')
      return response.data
    },
    onSuccess: () => {
      // atualize as chaves que fazem sentido na sua UI
      queryClient.invalidateQueries({ queryKey: ['agreement'] })
      queryClient.invalidateQueries({ queryKey: ['agreement-edit'] })
    }
  })
}
